export const SUPPORT_EMAIL = 'suporte@cancaooracao.com';
export const SITE_NAME = 'CançãoOração';
export const SITE_URL = 'cancaooracao.com';

export const PRICE_ORIGINAL = 'R$ 294';
export const PRICE_NOW = 'R$ 147';
export const PRICE_EXPRESS = 'R$ 187';
export const PRICE_EXPRESS_UPGRADE = 'R$ 40';

export const LOGO_URL = '/logo.png';
